import {
    CartIconComponent as SourceCartIconComponent,
} from 'SourceComponent/CartIcon/CartIcon.component';
import {ReactElement} from 'Type/Common.type';

import './CartIcon.override.style';

/** @namespace Steinkrueger/Component/CartIcon/Component */
export class CartIconComponent extends SourceCartIconComponent {
    render(): ReactElement {
        const { isActive } = this.props;

        return (
            <svg
              block="CartIcon"
              mods={ { isActive } }
              xmlns="http://www.w3.org/2000/svg"
              width="29"
              height="29"
              viewBox="0 0 29 29"
              fill="none"
            >
                <path
                  d="M27.209 6.0836H8.51292V4.33282C8.51292 2.46127 6.98737
                    1 5.1801 1H1.79102C1.35416 1 1 1.35416 1 1.79102C1 2.22787
                    1.35416 2.58203 1.79102 2.58203H5.1801C6.11767 2.58203
                    6.93089 3.33983 6.93089 4.33282V24.6672C6.93089 26.505
                    8.42602 28 10.2637 28C11.8289 28 13.1447 26.9152
                    13.5009 25.4582H18.8883C19.2444 26.9152 20.5603 28 22.1254
                    28C23.9632 28 25.4582 26.5049 25.4582 24.6672C25.4582
                    22.8295 23.9631 21.3344 22.1254 21.3344C20.5603 21.3344 19.2444
                    22.4192 18.8883 23.8762H13.5009C13.1447 22.4192 11.8289 21.3344
                    10.2637 21.3344C9.62182 21.3344 9.02207 21.5172
                    8.51292 21.833V19.5274H23.82C26.1249 19.5274
                    28.0001 17.6522 28.0001 15.3473V6.87462C28
                    6.43777 27.6459 6.0836 27.209 6.0836ZM22.1254
                    22.9164C23.0908 22.9164 23.8762 23.7018 23.8762 24.6672C23.8762
                    25.6326 23.0908 26.418 22.1254 26.418C21.1601 26.418 20.3747
                    25.6326 20.3747 24.6672C20.3747 23.7019 21.1601 22.9164
                    22.1254 22.9164ZM10.2637 22.9164C11.2291 22.9164 12.0144
                    23.7018 12.0144 24.6672C12.0144 25.6326 11.2291 26.418
                    10.2637 26.418C9.2983 26.418 8.51292 25.6326 8.51292
                    24.6672C8.51292 23.7019 9.2983 22.9164 10.2637
                    22.9164ZM26.418 15.3473C26.418 16.7799 25.2525 17.9454
                    23.8199 17.9454H8.51292V7.66564H26.418V15.3473Z"
                  fill="#003E90"
                  stroke="#003E90"
                  strokeWidth="0.5"
                />
            </svg>
        );
    }
}

export default CartIconComponent;
